// ============================================================================
// LES MOTIFS QUE L'ÉCRAN ÉCRIT LUI-MÊME — envoyés au serveur sous leur CLÉ française, traduits à la lecture.
//
// ⚠️ UNE CHAÎNE QUI PART AU SERVEUR N'EST PLUS UN TEXTE (Forme CQ) : envoyé traduit, le même motif était enregistré
//    dans la langue de qui cliquait — un compte anglais écrivait « Left negative » dans le journal d'un magasin dont les
//    collègues lisent le français, et l'export du comptable mêlait deux langues pour une même raison.
// ⚠️ LE FRANÇAIS EST LA CLÉ : ce que les comptes français ont déjà enregistré EST la clé — rien à migrer, et la lecture
//    le traduit comme le reste.
// ⚠️ UN MOTIF QUI N'EST PAS L'UN DES NÔTRES SE REND TEL QUEL : celui du référentiel (déjà un libellé du magasin) ou
//    une saisie libre ne se traduisent pas — les passer par `t()` les ferait réclamer au catalogue.
// ============================================================================
import { key, keyText, t, type DeclaredKey } from './i18n';

/** Les motifs que les écrans posent d'eux-mêmes. */
export const WRITTEN_REASONS = {
  negativeAwaitingReceipt: key('Laissé négatif — réception attendue'),
  seenWithSupplier: key('Vu avec le fournisseur'),
  cannotBeScanned: key('Impossible à scanner'),
} as const;

/** Ce qui part au serveur : la clé, identique quelle que soit la langue de qui écrit. */
export function reasonToSend(reason: DeclaredKey): string {
  return keyText(reason);
}

/** Ce qu'on affiche d'un motif lu : traduit s'il est l'un des nôtres, tel quel sinon. */
export function readReason(stored: string): string {
  const ours = Object.values(WRITTEN_REASONS).find((k) => keyText(k) === stored);
  return ours ? t(ours) : stored;
}
